import globalHook, { type Store } from 'utils/globalHook';

export interface CsrfState {
  name: string | null;
  value: string | null;
}

let busy = false;

const initialState: CsrfState = {
  name: null,
  value: null,
  ...window.initialCSRF,
};

const actions = {
  refresh: (store: Store<CsrfState>) => {
    if (!busy) {
      busy = true;
      fetch('/actions/blitz/csrf/token')
        .then(result => {
          return result.text();
        })
        .then(value => {
          store.setState({ value });
          busy = false;
        })
        .catch(() => {
          busy = false;
        });
    }
  },
};

export default globalHook(initialState, actions);
